"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestCredentials = void 0;
const credential_1 = require("./credential");
class GuestCredentials {
    constructor() {
        this.type = credential_1.CredentialType.Guest;
    }
    getToken() {
        return this.jwt;
    }
    authorize(authService) {
        return __awaiter(this, void 0, void 0, function* () {
            const jwt = yield authService.guestLogin();
            this.jwt = jwt;
            return jwt;
        });
    }
    refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            // You can't refresh a guest token
            return this.jwt;
        });
    }
    isRefreshable() {
        return false;
    }
}
exports.GuestCredentials = GuestCredentials;
//# sourceMappingURL=guest-credentials.js.map